/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@carbon/react';
import { emptyArray, emptyObject } from '../../../Utilities/propHelpers/defaultProps.js';

var tagsRegex = /<(a|span|code)>([^<]+)<\/[^>]+>/g;
var splitRegex = /<[^>]+>[^<]+<\/[^>]+>/;
var renderElement = function renderElement(el, tagProps, map) {
  var type = el[1];
  var content = el[2];
  var element;
  if (map[type]) {
    var Component = map[type];
    return /*#__PURE__*/React.createElement(Component, tagProps, content);
  }
  if (type === 'a') return /*#__PURE__*/React.createElement(Link, _extends({
    inline: true
  }, tagProps), content);
  if (type === 'span') return /*#__PURE__*/React.createElement("span", tagProps, content);
  if (type === 'code') return /*#__PURE__*/React.createElement("code", tagProps, content);
  return element;
};
var Translate = function Translate(_ref) {
  var _ref$tagProps = _ref.tagProps,
    tagProps = _ref$tagProps === void 0 ? emptyArray : _ref$tagProps,
    _ref$tagMap = _ref.tagMap,
    tagMap = _ref$tagMap === void 0 ? emptyObject : _ref$tagMap,
    children = _ref.children;
  var parts = children.split(splitRegex);
  var elements = [];
  var match;
  // eslint-disable-next-line no-cond-assign
  while ((match = tagsRegex.exec(children)) !== null) {
    elements.push(match);
  }
  var content = parts.map(function (text, i) {
    var el = elements[i];
    var p = tagProps[i] || {};
    if (el) return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Fragment, {
        key: i
      }, text, renderElement(el, p, tagMap))
    );
    return text;
  });
  return /*#__PURE__*/React.createElement("span", {
    className: "cpc--translate"
  }, content);
};
Translate.propTypes = {
  /**
   * The string from the translation bundle, with tags embedded.
   */
  children: PropTypes.string.isRequired,
  /**
   * Array of properties for each element / component created. The array index corresponds to the index
   * of each tag in the string.
   */
  tagProps: PropTypes.arrayOf(PropTypes.shape({})),
  /**
   * Each tag has a default HTML element or component that it maps to, but you can use this to override
   * the mapping and use a different React component. For example, to render a react-router Link instead
   * of a carbon Link, map the `a` tag to the `Link` component (tagMap={{ a: Link }}).
   */
  tagMap: PropTypes.shape({
    a: PropTypes.elementType,
    span: PropTypes.elementType,
    code: PropTypes.elementType
  })
};
var Translate$1 = Translate;

export { Translate$1 as default };
